import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { ScreeningPscInspection } from "../../types/Screening";
import { getSummaryAggregates } from "../../utils/pscHelper";

type Props = {
    pscInspections: ScreeningPscInspection[];
};

export const ScreeningPSCAggregates = (props: Props) => {
    const { pscInspections } = props;

    const { t } = useTranslation("locale");

    const aggregates = useMemo(
        () => getSummaryAggregates(pscInspections),
        [pscInspections]
    );

    return (
        <div className="grid flex mt-3 mr-0 ml-0 mb-3 gap-3">
            <div className="col-4 md:col p-0">
                <span className="psc-aggregate-label">
                    {t("psc.inspectionsTotal")}
                </span>
                <span className="psc-aggregate-count mt-1">
                    {aggregates.inspectionsTotal}
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="psc-aggregate-label">
                    {t("psc.deficienciesTotal")}
                </span>
                <span className="psc-aggregate-count mt-1">
                    {aggregates.deficienciesTotal}
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="psc-aggregate-label">
                    {t("psc.detentionsTotal")}
                </span>
                <span className="psc-aggregate-count mt-1">
                    {aggregates.detentionsTotal}
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="psc-aggregate-label">
                    {t("psc.deficiencyPerInspection")}
                </span>
                <span className="psc-aggregate-count mt-1">
                    {aggregates.deficiencyPerInspection}
                </span>
            </div>
            <div className="col-4 md:col p-0">
                <span className="psc-aggregate-label">
                    {t("psc.detentionRate")}
                </span>
                <span className="psc-aggregate-count mt-1">
                    {aggregates.detentionRate}%
                </span>
            </div>
        </div>
    );
};
